import { experimentalStyled } from '@material-ui/core/styles';

const Logo = (props) => (<img height="52" width="52" style={{display: "block"}} src={'/static/revpower-logo-blue.png'}></img>);

export default Logo;
